import { render } from "./TicketsPage.vue?vue&type=template&id=21edcbd8&scoped=true&ts=true"
import script from "./TicketsPage?vue&type=script&lang=ts"
export * from "./TicketsPage?vue&type=script&lang=ts"

import "./TicketsPage.vue?vue&type=style&index=0&id=21edcbd8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21edcbd8"]])

export default __exports__